import { defineAction } from '@cheesecakelabs/boilerplate/utils'

import * as reconcileService from '_services/reconcile'

export const GET_RECONCILE_ITEMS = defineAction('GET_RECONCILE_ITEMS')
export const CHECK_RECONCILE_ITEM = defineAction('CHECK_RECONCILE_ITEM')

export const getReconcileItems = () => (dispatch, getState) =>
  dispatch({
    type: GET_RECONCILE_ITEMS.ACTION,
    payload: reconcileService.getReconcileItems(getState().user.get('token')),
  })

export const checkReconcileItem = payload => (dispatch, getState) =>
  dispatch({
    type: CHECK_RECONCILE_ITEM.ACTION,
    payload: reconcileService
      .checkReconcileItem(getState().user.get('token'))(payload)
      .then(() => reconcileService.getReconcileItems(getState().user.get('token'))),
  })



// WEBPACK FOOTER //
// ./src/modules/reconcile/actions.js